import { Button } from "primereact/button";
import styled from "styled-components";
import { device } from "../../../constants/mediaQueries";
import { ControlledMenu } from "@szhsin/react-menu";

const desktopMenuWidth = "270px";

export const StyledProfileBtn = styled(Button)`
  &.cvp-profile-btn {
    &.p-button.p-button-icon-only {
      width: 2rem;
      height: 2rem;
      padding: 0;
      border-radius: 50%;

      @media ${device.md} {
        width: 2.357rem;
        height: 2.357rem;
      }
    }

    .pi {
      font-size: 0.9rem;

      @media ${device.md} {
        font-size: 1rem;
      }
    }

    background-color: var(--primary-100);
    border: none;
    color: var(--primary-color);

    &:hover:not(:disabled) {
      background-color: var(--primary-200);
      color: var(--primary-color);
    }
    &:active:not(:disabled) {
      border: none;
    }
    &:focus:not(:disabled) {
      box-shadow: none;
    }
  }
`;

export const StyledProfileDropdown = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  border: 1px solid var(--primary-100-relative);
  border-radius: 4px;
  padding: 0.25rem 0.65rem 0.25rem 0.3rem;
  width: ${desktopMenuWidth};
  transition: background-color 0.12s, border-color 0.12s;

  &:hover {
    cursor: pointer;
    background-color: var(--primary-50-relative);
    border-color: var(--primary-200-relative);
  }

  .cvp-topbar-avatar {
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    background: var(--primary-100);
    color: var(--primary-color);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 0.8rem;
    font-weight: 700;
    letter-spacing: 0.02em;
    flex: 0 0 auto;

    > i.pi {
      font-size: 0.9rem;
      line-height: 1;
    }
  }

  &[data-avatar-color="blue"]   .cvp-topbar-avatar { background: var(--blue-100);   color: var(--blue-600); }
  &[data-avatar-color="indigo"] .cvp-topbar-avatar { background: var(--indigo-100); color: var(--indigo-600); }
  &[data-avatar-color="purple"] .cvp-topbar-avatar { background: var(--purple-100); color: var(--purple-600); }
  &[data-avatar-color="pink"]   .cvp-topbar-avatar { background: var(--pink-100);   color: var(--pink-600); }
  &[data-avatar-color="cyan"]   .cvp-topbar-avatar { background: var(--cyan-100);   color: var(--cyan-600); }
  &[data-avatar-color="teal"]   .cvp-topbar-avatar { background: var(--teal-100);   color: var(--teal-600); }
  &[data-avatar-color="orange"] .cvp-topbar-avatar { background: var(--orange-100); color: var(--orange-600); }
  &[data-avatar-color="yellow"] .cvp-topbar-avatar { background: var(--yellow-100); color: var(--yellow-600, #b45309); }
`;

export const StyledSimpleProfileDropdown = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  .pi-user {
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    background-color: var(--primary-100);
    color: var(--primary-color);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 0.9rem;
    line-height: 1;

    @media ${device.md} {
      font-size: 1rem;
    }
  }

  &:hover {
    cursor: pointer;
  }
`;

export const StyledReactControlledMenu = styled(ControlledMenu)`
  &.cvp-react-menu > .szh-menu {
    padding: 0.3rem 0 0 0;
    min-width: 230px;
    width: max-content;
    max-width: calc(100vw - 1rem);

    transform-origin: top center;

    @media ${device.md} {
      min-width: ${desktopMenuWidth};
    }
  }

  .szh-menu {
    background: var(--surface-a);
    border: var(--popup-border-thickness) solid var(--surface-d);
  }

  .szh-menu__item {
    padding: 0.7rem 1rem;
    font-size: 0.9rem;
    gap: 0.5rem;
    width: 100%;
    color: var(--text-color);

    &.vpn-item {
      color: var(--red-500);
    }

    &--anchor {
      color: var(--text-color);
      text-decoration: none;
    }

    &--hover {
      background: color-mix(in srgb, var(--primary-500) 8%, transparent);
      -webkit-transition: all ease-out 0.3s;
      -moz-transition: all ease-out 0.3s;
      -o-transition: all ease-out 0.3s;
      transition: all ease-out 0.3s;
    }
  }

  .szh-menu__item.cvp-profile-row.active,
  .szh-menu__item.cvp-profile-row.active.szh-menu__item--hover {
    background: var(--primary-100);
  }

  .szh-menu__item.szh-menu__item.guid {
    padding: 0.3rem 1rem;
    font-size: 0.7rem;
    color: var(--text-color-secondary);
    background-color: var(--surface-100);
    border-bottom-left-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;

    i {
      font-size: 0.7rem;
    }
  }
  .szh-menu__divider {
    margin: 0;
    background-color: var(--primary-200-relative);
  }

  .szh-menu__submenu > .szh-menu__item::after {
    content: "";
    position: absolute;
    right: 0;
  }


  .szh-menu__submenu.vpn-item > .szh-menu__item {
    color: var(--red-500);
  }
  .szh-menu__submenu.vpn-item > .szh-menu__item {
    padding: 0.35rem 0.5rem;
    margin: 0.35rem 0.5rem;
    width: auto;
    border: 1px dashed var(--red-500);
  }


  .subMenu-item-template {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    .icon-label {
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }

    .pi-angle-right {
      margin-left: 0.5rem;
    }
  }

  .szh-menu__item.profile-switcher {
    padding: 0.45rem 1rem 0.45rem 2.5rem;
    font-size: 0.8rem;
    color: var(--text-color-secondary);
    background-color: var(--primary-100-relative);
    border-top: 1px solid var(--surface-d);

    &.szh-menu__item--hover {
      background: var(--primary-50-relative);
      color: var(--primary-500-relative);
    }

    &.active {
      color: var(--primary-500-relative);
      font-weight: 600;
    }

    i.pi {
      font-size: 0.8rem;
    }
  }

  /* Collapse the border between consecutive profile-switcher rows so the group reads as one block under the concern row. */
  .szh-menu__item.profile-switcher + .szh-menu__item.profile-switcher {
    border-top: none;
  }

  .department {
    .szh-menu__item--submenu {
      padding: 0;
      background-color: var(--primary-100-relative);
    }

    /* Restore normal padding for nested submenu triggers (e.g. per-concern groups with multiple profiles) */
    .szh-menu .szh-menu__item--submenu {
      padding: 0.7rem 1rem;
      background-color: transparent;
    }

    .szh-menu__divider.cvp-profile-concern-group-divider {
      margin: 0.35rem 0.75rem;
      height: 0;
      border-top: 1px solid var(--surface-d);
      background: none;
    }
  }

  .szh-menu.cvp-profile-group-popup {
    width: max-content;
    max-width: calc(100vw - 1rem);
    box-sizing: border-box;

    .szh-menu__item {
      white-space: normal;
      overflow-wrap: anywhere;
      word-break: break-word;
      min-width: 0;
    }
  }

  .language-short-label {
    width: 1.7em;
    font-weight: 500;
    color: var(--surface-500);
  }

  .active,
  .active .language-short-label {
    color: var(--primary-500-relative);
    font-weight: bold;
  }

  // animation

  @keyframes szh-menu-show-slide-bottom {
    from {
      opacity: 0;
    }
  }

  @keyframes szh-menu-fade-out {
    to {
      opacity: 0;
    }
  }

  .szh-menu--state-opening.szh-menu--dir-bottom {
    animation: szh-menu-show-slide-bottom 120ms cubic-bezier(0, 0, 0.2, 1);
  }

  .szh-menu--state-closing.szh-menu--dir-bottom {
    animation: szh-menu-fade-out 0.1s linear forwards;
  }
`;
